<template>
  <div class="pa-10">
    <InternFeedbackDatatable />
  </div>
</template>

<script>
import InternFeedbackDatatable from "@/components/Utils/InternFeedbackDatatable.vue";

export default {
  components: {
    InternFeedbackDatatable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
